import ApplicationsList from "../../components/Jupiter/ApplicationsList/ApplicationsList.jsx";
import Header from "../../components/Jupiter/Header/Header.jsx";
import Jupiter from "../../components/Jupiter/Jupiter.jsx";

const JupiterDashboard = () => {
  return (
    <>
      <Jupiter>
        <div className="container mx-auto px-4 py-8">
          <Header />

          {/* {process.env.NODE_ENV === "development" && (
            <div className="my-4 text-xs bg-gray-100 rounded p-2">
              <h5>Development mode</h5>
              {JSON.stringify(session)}
            </div>
          )} */}

          <ApplicationsList />
        </div>
      </Jupiter>
    </>
  );
};

export default JupiterDashboard;
